import apiRequest from './wrapper';

/**
 * @method : GET
 * @path   : /users/me/trainings
 * @desc   : get all trainings.
 */
export const getRecommendedTrainings = (pathParam, params) => {
  return new Promise((resolve, reject) => {
    apiRequest('get', '/users/me/trainings/', { params }, pathParam)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/**
 * @method : PUT
 * @path   : /users/me/trainings/{soc3}/{training_id}
 * @desc   : update training rating
 */
export const updateTrainings = (training, rating) => {
  return new Promise((resolve, reject) => {
    apiRequest('put', `/users/me/trainings/${training.soc3}/${training.id}`, { data: { rating } })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            // handle unauthorized error
            errorMessage = 'updateTrainings: You are not authorized to perform this action';
          } else if (status === 404) {
            // handle not found error
            errorMessage = 'updateTrainings: The resource you are trying to access was not found';
          } else if (status >= 500) {
            // handle server error
            errorMessage = 'updateTrainings: An error occurred on the server';
          } else {
            errorMessage = data.message;
          }

          reject(new Error(errorMessage));
        } else if (error.request) {
          // The request was made but no response was received
          reject(new Error('updateTrainings: No response was received from the server'));
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error);
        }
      });
  });
};
